import React, { useState } from "react";
import { Card, Col, OverlayTrigger, Placeholder, Tooltip } from "react-bootstrap";
import { motion } from "framer-motion";
import { useRouter } from "next/navigation";
import imagePlaceholder from "../../../public/images/imagePlaceholder.png";
import styles from "../../styles/RelatedModels.module.css"
import LoadingCard from "./ProductCardLoading";
import Image from "next/image";
import Link from "next/link";
import { marketplaceCdn } from "../../utility/env";
import { replaceSpecialCharacters } from "../../utility/Images/utils";
import { useUserStore } from "../../store/User";
import { model_visit } from "../../UserEvents/UserEvents";
import { trackModelVisit } from "../../utility/UserEvents";

interface productProp {
  title: string;
  modelId: number;
  imageUrl: string;
  category: string;
}

interface heightType {
  height: {
    delay: number;
    duration: number;
  };
}
const ProductCard: React.FC<productProp> = ({ title, modelId, imageUrl, category }) => {
  const router = useRouter();
  const [imageSrc,setImageSrc]=useState(`${marketplaceCdn}/${imageUrl}`)
  const { user, token } = useUserStore((state: any) => state);

  return (
    <Link
      onClick={() =>
        trackModelVisit(
          modelId,
          user?.uuid,
          category,
          title,
          `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}specs/${category}/${replaceSpecialCharacters(title.replaceAll(" ", "-").replaceAll("/", "").replaceAll('"', "").replaceAll("--", ""))}-${modelId}`
        )
      }
      href={`/specs/${category}/${replaceSpecialCharacters(title.replaceAll(" ", "-").replaceAll("/", "").replaceAll('"', "").replaceAll("--", ""))}-${modelId}`}
    >
      <div className={`${styles.card}`}>
        <div className={`${styles.cardImg}`}>
          <Image
            alt="modelImage"
            src={imageSrc}
            width={300}
            height={300}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            onError={(e) => setImageSrc(`${imagePlaceholder.src}`)}
          />
        </div>
        <p className={`${styles.cardText}`}>{title}</p>
      </div>
    </Link>
  );
};

export default ProductCard;
